module.exports = __webpack_public_path__ + "static/media/VisbyCF-MediumOblique.437e160e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/VisbyCF-MediumOblique.woff
// module id = 798
// module chunks = 0